import Rails from '@rails/ujs'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  updateAdjustedClusterValue (e) {
    Rails.fire(e.target.parentElement, 'submit')
  }
}
